import { Injectable } from '@angular/core';
import { Business } from 'src/app/types/Business';
import { BusinessSummary } from 'src/app/types/BusinessSummary';
import { BusinessSummaryRequest } from '../../../types/requests/BusinessSummaryRequest';
import { CoreService } from '../../core.service';
import { IBusinessSummaryService } from '../IBusinessSummaryService';
import { mockBusinesses, mockBusinessSummary } from './mock-data';

@Injectable({
  providedIn: 'root',
})
export class MockBusinessSummaryService implements IBusinessSummaryService {
  constructor(private _coreService: CoreService) {}

  leaveBusiness(businessId: string): Promise<BusinessSummary> {
    let remaining = mockBusinessSummary.businesses.filter(
      (business) => business.r2AId === businessId,
    );
    return this._coreService.delayResolve({
      ...mockBusinessSummary,
      businesses: remaining,
    });
  }

  async getBusinessSummary(
    businessSummaryRequest: BusinessSummaryRequest,
  ): Promise<BusinessSummary> {
    console.log('Fetching business summary for', businessSummaryRequest);
    return this._coreService.delayResolve(mockBusinessSummary);
  }

  async getAllClientBusinesses(): Promise<Business[]> {
    //console.log('Fetching business summary for', businessSummaryRequest);
    return this._coreService.delayResolve(mockBusinesses);
  }

  async getClientBusinessById(clientId: string): Promise<Business> {
    return this._coreService.delayResolve(mockBusinesses[0]);
  }
}
